import { z } from 'zod'
import { LEGAL_DOCUMENT_LOCALES, LegalDocumentType } from '@/types/legalDocument'

export const legalDocumentPublishSchema = z.object({
  type: z.enum(LegalDocumentType),
  locale: z.enum(LEGAL_DOCUMENT_LOCALES),
  content: z.string().min(1),
})

export type LegalDocumentPublishInput = z.infer<typeof legalDocumentPublishSchema>

// Acceptation d'une version par l'utilisateur courant. L'utilisateur n'est PAS dans le
// payload : le back le prend depuis le token, personne ne peut accepter pour un autre.
// `version` doit être le `referenceVersion` renvoyé par legal_documents/pending — le back
// rejette toute autre valeur (onglet resté ouvert pendant une republication, rejeu).
export const legalDocumentAcceptSchema = z.object({
  type: z.enum(LegalDocumentType),
  version: z.number().int().positive(),
  locale: z.enum(LEGAL_DOCUMENT_LOCALES),
})

export type LegalDocumentAcceptInput = z.infer<typeof legalDocumentAcceptSchema>
